var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-skeleton-loader',{staticClass:"full-width",attrs:{"type":"table"}}):_c('TabbedDataTable',{attrs:{"tabs":_vm.tabs},on:{"exportItems":_vm.exportItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }